const flexWrap = {
    name: "flex-wrap",
    path: "/flex-wrap",
    title: "flex-wrap",
    description: "Utilities for controlling how flex items wrap.",
    value: {
        "flex-wrap": {
            "flex-wrap": "wrap",
            "flex-wrap-reverse": "wrap-reverse",
            "flex-nowrap": "nowrap",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="flex flex-nowrap">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex flex-wrap">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex flex-wrap-reverse">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex flex-wrap md:flex-wrap-reverse ...">
  <!-- ... -->
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex-nowrap</code>
                  to prevent flex items from wrapping, causing inflexible items to overflow the container if necessary:
            </p>

            <div class="relative">
                <div class="absolute inset-0 -z-1">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex flex-row flex-nowrap overflow-x-auto space-x-4 font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">01</div>
                    </div>
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">02</div>
                    </div>
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">03</div>
                    </div>
                </div>
            </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex-wrap</code>
                   to allow flex items to wrap:
            </p>

            <div class="relative">
                <div class="absolute inset-0 -z-1">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex flex-row flex-wrap overflow-x-auto gap-4 font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">01</div>
                    </div>
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">02</div>
                    </div>
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">03</div>
                    </div>
                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex-wrap-reverse</code>
                  to wrap flex items in the reverse direction:
            </p>

            <div class="relative">
                <div class="absolute inset-0 -z-1">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex flex-row flex-wrap-reverse overflow-x-auto gap-4 font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">01</div>
                    </div>
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">02</div>
                    </div>
                    <div class="flex-none w-2/5">
                        <div class="flex h-14 w-full items-center justify-center rounded-lg bg-color-sky-500">03</div>
                    </div>
                </div>
            </div>
        
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex-wrap</code>
                 utility with a breakpoint variant like md: to only apply the utility at medium screen sizes and above:
            </p>        
            `
        },
    ]
};

export default flexWrap;

<div className="sr-only">

    <div class="flex-none flex-wrap flex-wrap-reverse w-2/5 flex flex-row -z-1 flex-col-reverse flex-row-reverse flex-col gap-x-4 font-mono text-sm leading-6 font-bold text-color-white">
        <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">01</div>
        <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">02</div>
        <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">03</div>
    </div>

</div>